module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"customer":"Customer","customAddress":"Custom Address","edit":"Edit","failedToFetch":"Failed to search for addresses"},"no":{"customer":"Kunde","customAddress":"Ny adresse","edit":"Rediger","failedToFetch":"Kunne ikke søke etter adresser"}}')
  delete Component.options._Ctor
}
